import { Route, Routes, Navigate } from "react-router-dom";
import { useState, useEffect, useContext } from "react";
import Home from "./pages/home/Index";

import EngResult from "./pages/result/Index_Eng";
import PresatResult from "./pages/result/Index";

import SignupPanel from "./login/signup";
import SignInForm from "./login/login";
import ForgotPasswordForm from "./login/passwordreset";
import Dashboard from "./pages/dashboard/Index";
import TDashboard from "./pages/dashboard/TIndex";
import WorksheetPDF from "./pages/dashboard/WorksheetPDF";
import PDashboard from "./pages/dashboard/PIndex";

import DevQuiz89 from "./pages/dev_quiz89/Index";
import DevQuiz10 from "./pages/dev_quiz10/Index";
import DevQuiz from "./pages/dev_quiz/Index";
import DevACT from "./pages/dev_act/Index";
import DevQuizAPCALC from "./pages/dev_apcalc/Index";

import CourseComponent from "./pages/dev_class/dev_course";
import LessonPage from "./pages/dev_class/lesson";
import LessonEditor from "./pages/dev_class/lesson_editor";
import ReviewCourse from "./pages/dev_class/review_course";

import SATQuiz from "./pages/sat/Index";
import ACTQuizfromdashboard from "./pages/act_quiz/Index";
import APQuiz from "./pages/ap_quiz/Index";

import PresetSAT from "./pages/presetsat/Index";
import ACTScoreboard from "./pages/result/ACT_index";
import PresetAP from "./pages/ap/Index";

import SatAnswers from "./pages/digital_answers/Digital_sat_answers";
import ACTQuiz from "./pages/act/Index";
import { UserContext } from "./context/UserContext";
import RoleCheck from "./RoleCheck";

import CDevQuiz from "./pages/dev_quiz/c_sat_body";
import Main_review from "./pages/dev_quiz/main_review";

const App = () => {
  const { user } = useContext(UserContext);
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    const storedAuth = localStorage.getItem("isAuthenticated");
    return storedAuth === "true"; // true if stored value is 'true'
  });

  useEffect(() => {
    document.title = "Problem Vault";
  }, []);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem("isAuthenticated", "true");
  };

  return (
    <div>

      {/*
        <Route element={<Home />} path="/dev" />
        <Route element={<CDevQuiz />} path="/create/devpsat" />
        <Route element={<DevQuiz />} path="/devpsat/:id" />
        <Route element={<DevQuiz89 />} path="/devpsat89/:id" />
        <Route element={<DevQuiz10 />} path="/devpsat10/:id" />
        <Route element={<DevACT />} path="/devact/:id" />
        <Route element={<DevQuizAPCALC />} path="/devapcalc/:id" />

        <Route element={<Main_review />} path="/review/psat" />
        <Route element={<RandomSATReady89 />} path="/psat89" />
        <Route element={<RandomSATReady10 />} path="/psat10" />
        <Route element={<Topic89 />} path="/psat89/topic" />
        <Route element={<Topic10 />} path="/psat10/topic" />
        <Route element={<FreeTopic />} path="/freetrial/mathquiz" />
        */}

      <Routes>
        <Route element={<SATQuiz />} path="/sat/quiz" />

        <Route
          element={<PresetSAT free={true} freesat={"sat1"} />}
          path="freetrial/sat"
        />
        <Route element={<SATQuiz />} path="freetrial/engquiz" />

        <Route element={<Dashboard />} path="/main" />
        <Route element={<TDashboard />} path="/main/teacher" />
        <Route element={<TDashboard />} path="/main/teacher/:classid" />
        <Route element={<WorksheetPDF />} path="/main/teacher/:classid/pdf/:quizid" />
        <Route element={<PDashboard />} path="/main/parents" />
        <Route element={<Dashboard />} path="/main/:section/courses/:courseSlug" />
        <Route element={<Dashboard />} path="/main/sat/:classid" />
        <Route element={<Dashboard />} path="/main/:section/:tab" />
        <Route element={<Dashboard />} path="/main/:section" />

        <Route element={<ACTQuiz />} path="/act/preset/quiz/:id" />
        <Route element={<ACTScoreboard />} path="/results/act/:id" />
        <Route element={<EngResult />} path="/results/act/quiz/:id" />
        <Route element={<ACTQuizfromdashboard />} path="/act/quiz" />

        <Route element={<PresetAP />} path="/ap/preset/apcalcab/:id" />
        <Route element={<PresetAP />} path="/ap/preset/apcalcbc/:id" />
        <Route element={<APQuiz />} path="/ap/quiz" />
        <Route element={<EngResult />} path="/results/ap/quiz/:id" />

        <Route element={<Home />} path="/dev" />
        <Route element={<CDevQuiz />} path="/create/devpsat" />
        <Route element={<DevQuiz />} path="/devpsat/:id" />
        <Route element={<DevQuiz89 />} path="/devpsat89/:id" />
        <Route element={<DevQuiz10 />} path="/devpsat10/:id" />
        <Route element={<DevACT />} path="/devact/:id" />
        <Route element={<DevQuizAPCALC />} path="/devapcalc/:id" />
        <Route element={<Main_review />} path="/review/devpsat" />

        <Route element={<CourseComponent />} path="/dev/class" />
        <Route element={<LessonPage />} path="/dev/class/:cid/lesson" />
        <Route element={<LessonEditor />} path="/dev/class/:cid/lesson/edit/:lid" />
        <Route element={<ReviewCourse />} path="/dev/class/:cid/lesson/review" />
        {/* Additional routes (commented out code removed) */}

        <Route element={<PresetSAT />} path="/sat/preset/quiz/:id" />
        <Route element={<SatAnswers />} path="/digital/answer/:folderType" />

        <Route element={<PresatResult />} path="/results/presat/:id" />
        <Route element={<EngResult />} path="/results/sat/quiz/:id" />

        <Route
          path="/signup"
          element={
            isAuthenticated && user ? (
              <RoleCheck user={user} />
            ) : (
              <SignupPanel onLogin={handleLogin} />
            )
          }
        />
        <Route element={<ForgotPasswordForm />} path="/reset/passwrod" />
        <Route
          path="/login"
          element={
            isAuthenticated && user ? (
              <RoleCheck user={user} />
            ) : (
              <SignInForm onLogin={handleLogin} />
            )
          }
        />

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </div>
  );
};

export default App;
